import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { User } from '@iotv/datamodel-core';
import { Avatar, CircularProgress, Popover, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { getImageUrl, putPublic } from '../../data/aws/s3/UserBlobs';
const debug = process.env.REACT_APP_DEBUG && false;
export const UserAvatarSelector = ({ contextUser, subjectUser, userFunctions, transactionFunctions }) => {
    const [imageUrl, setImageUrl] = useState('');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePopoverClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    useEffect(() => {
        async function effectUrl() {
            const objectOrString = (await getImageUrl(subjectUser, true)) ?? (await getImageUrl(subjectUser, false));
            if (typeof objectOrString === 'string') {
                const url = objectOrString;
                debug && console.log('Use Effect has url', url);
                setImageUrl(url);
            }
            else {
                setImageUrl('');
            }
        }
        effectUrl();
    }, [subjectUser?.sk, subjectUser?.primaryS3Image?.key]);
    const handleFileUpload = async (e) => {
        if (!subjectUser)
            return;
        debug && console.log(e.target.files);
        const fileList = e.target.files;
        const directoryString = `${subjectUser.sk}/`;
        if (fileList) {
            for (let i = 0, numFiles = fileList.length; i < numFiles; i++) {
                const file = fileList[i];
                if (file.size > 5 * 1024 * 1024) {
                    window.alert(`File too big!\nUploads are limited to 5 megabytes.`);
                    continue;
                }
                const progressCallback = (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    setUploadProgress((loaded / total) * 100);
                    if (loaded === total) {
                        setTimeout(() => setUploadProgress(0), 1000);
                    }
                };
                try {
                    const uploadRes = await putPublic(directoryString, file, progressCallback);
                    debug && console.log('uploadRes', uploadRes);
                    const clone = new User(subjectUser);
                    clone.primaryS3Image = uploadRes;
                    transactionFunctions.saveObject(clone);
                    userFunctions.addObjectsToState([clone]);
                    if (clone.sk === contextUser?.sk) {
                        userFunctions.setUser(clone);
                    }
                }
                catch (error) {
                    console.log('Error uploading file: ', error);
                }
            }
        }
    };
    return (_jsxs(Stack, { sx: { justifyContent: 'center', alignItems: 'center' }, children: [_jsx("input", { id: "profilePic", accept: "image/*", type: "file", hidden: true, onChange: (e) => handleFileUpload(e) }), uploadProgress > 0 ? (_jsx(CircularProgress, { variant: "determinate", value: uploadProgress, size: "8em", sx: { padding: 4 } })) : (_jsx("label", { htmlFor: "profilePic", children: _jsx(Avatar, { onMouseEnter: handlePopoverOpen, onMouseLeave: handlePopoverClose, sx: { cursor: 'pointer', height: '2em', width: '2em', fontSize: '6em' }, src: imageUrl, alt: subjectUser?.name ?? '', children: subjectUser?.name?.replaceAll(/[^A-Z]/g, '') }) })), _jsx(Popover, { open: open, anchorEl: anchorEl, anchorOrigin: { vertical: 'center', horizontal: 'center' }, transformOrigin: { vertical: 'center', horizontal: 'center' }, onClose: handlePopoverClose, disableRestoreFocus: true, sx: { pointerEvents: 'none' }, children: _jsx(Typography, { sx: { padding: 1 }, children: "Edit picture" }) })] }));
};
